import { Tag } from 'primereact/tag'

import { Supplier } from '../../features/selfservice/suppliers/data'
import i18n from '../../utils/i18n'

export const ActiveBodyTemplate = (
  status: Supplier['Status'],
  showTag?: boolean | null,
) => {
  if (!status) return null
  if (showTag === false) return null

  return (
    <Tag
      value={i18n.t(`common.codes.status.${status}`)}
      className={status?.toLowerCase()}
    ></Tag>
  )
}
